const getAbValue = (name: string, abTests?: AbTests): AbTest['value'] => {
  let _abTests = abTests

  if (!_abTests && typeof window !== 'undefined') {
    _abTests = window.__globals__ && window.__globals__.abTests
  }

  if (!_abTests) {
    console.error('AbTests are not defined!')
    return 'a'
  }

  const abValue = _abTests[name]

  if (!abValue) {
    console.error(`AbTests item by key "${name}" not found!`)
    return 'a'
  }

  if (typeof abValue === 'string') {
    console.error(`AbTests item by key "${name}" is String!`)
    return abValue
  }

  return abValue.value || 'a'
}


export default getAbValue
